import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import styled from 'styled-components';
import { BsArrowRight } from 'react-icons/bs';
import Port410 from '../../images/portfolio/410-460.jpg';
import 'swiper/css';
import './portfolioList.css';
import gigs from './gigs';

const PortfolioList = () => {
  return (
    <div
      className='portfolio_list gallery_zoom wow fadeInUp'
      data-wow-duration='.7s'
    >
      <div className='swiper-container'>
        <div className='swiper-wrapper'>
          <Swiper
            modules={[Navigation, Pagination, Scrollbar, A11y]}
            lazy={true}
            spaceBetween={30}
            slidesPerView='auto'
            loop={true}
            // pagination={{ clickable: true }}
            navigation={{
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            }}
            scrollbar={{ draggable: true }}
          >
            {gigs.map((x) => {
              const { id, title, category, details, view, pertfolioImg } = x;
              return (
                <SwiperSlide key={id}>
                  <div className='swiper-slide'>
                    <div className='list_inner'>
                      <div className='image'>
                        <img src={Port410} alt='' />
                        <div
                          className='main'
                          data-img-url='img/portfolio/4.jpg'
                          style={{
                            background: `url(${pertfolioImg})`,
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                          }}
                        ></div>
                        <Overlay>
                          <div className='overlay'></div>
                          <a href={view} target='_blank'>
                            <BsArrowRight className='svg' />
                          </a>
                          <div className='details'>
                            <h3>{title}</h3>
                            <span>{category}</span>
                          </div>
                        </Overlay>
                      </div>
                      {/* <a className="kura_tm_full_link portfolio_popup" href="#"></a> */}
                      <div className='hidden_content'>
                        <div className='popup_details'>
                          <div className='main_details'>
                            <div className='textbox'>
                              <p>{details}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
        <div className='kura_tm_swiper_progress fill'>
          <div className='my_pagination_in'>
            <span className='current'></span>
            <span className='pagination_progress'>
              <span className='all'>
                <span></span>
              </span>
            </span>
            <span className='total'></span>
          </div>
          <div className='my_navigation'>
            <ul>
              <li>
                <a className='my_prev swiper-button-prev'>
                  <BsArrowRight className='svg' />
                </a>
              </li>
              <li>
                <a className='my_next swiper-button-next'>
                  <BsArrowRight className='svg' />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PortfolioList;

const Overlay = styled.div`
  .overlay {
    position: absolute;
    top: 10px;
    bottom: 10px;
    left: 10px;
    right: 10px;
    background-color: ${({ theme }) => theme.body} !important;
    border-radius: 10px;
    z-index: 1;
    opacity: 0;
    visibility: hidden;

    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -ms-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all 0.3s ease;
  }

  .details {
    color: ${({ theme }) => theme.text};
  }
`;
